export default __webpack_public_path__ + "static/media/372.5efe87af.jpg";